import request from '../../../utils/request';


export const getDealerProducts = '/dealerProduct/';

export const  getHospitalInContract = `/dealerProduct/hospital`;

export const getProductsByOrder = '/dealerProduct/byOrder';

export function getSuitDict(params:any){
    return request.post('/dealerProduct/suit', params);
}

export function importProductToCart(hospital:any, file: File){
    const formData = new FormData();
    formData.append('hospital', hospital?hospital.toString():'');
    formData.append('file', file);
    return request.post('/dealerProduct/importProductToCart', formData);
}